import React, { useEffect } from 'react';

const MentionsLegales: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Mentions Légales | SOS IT Services';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Mentions légales de SOS IT Services — éditeur, hébergeur, propriété intellectuelle et droit applicable.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', 'https://sos-it-services.fr/mentions-legales');
  }, []);

  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-white mb-2">Mentions Légales</h1>
        <p className="text-sm text-gray-400 mb-10">En vigueur au 31 mars 2026</p>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">1. Éditeur du site</h2>
          <p className="text-gray-300 leading-relaxed">
            Le site <span className="font-medium">sos-it-services.fr</span> est édité par :
          </p>
          <ul className="mt-3 space-y-1 text-gray-300">
            <li><span className="font-medium">Raison sociale :</span> EI Lucas OLIVE</li>
            <li><span className="font-medium">Nom commercial :</span> SOS IT Services</li>
            <li><span className="font-medium">Forme juridique :</span> Entreprise Individuelle</li>
            <li><span className="font-medium">SIRET :</span> 883 269 029 00038</li>
            <li><span className="font-medium">Adresse :</span> 485 route de la favorite, 74580 VIRY</li>
            <li>
              <span className="font-medium">Email :</span>{' '}
              <a href="mailto:contact@sos-it-services.fr" className="text-blue-600 hover:underline">
                contact@sos-it-services.fr
              </a>
            </li>
            <li>
              <span className="font-medium">Téléphone :</span>{' '}
              <a href="tel:0626748299" className="text-blue-600 hover:underline">
                06 26 74 82 99
              </a>
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">2. Directeur de publication</h2>
          <p className="text-gray-300 leading-relaxed">
            Le directeur de la publication est <span className="font-medium">Lucas OLIVE</span>, en
            sa qualité de responsable de l'entreprise individuelle EI Lucas OLIVE.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">3. Hébergeur</h2>
          <p className="text-gray-300 leading-relaxed">
            Le site est hébergé par :
          </p>
          <ul className="mt-3 space-y-1 text-gray-300">
            <li><span className="font-medium">Société :</span> UAB "Hostinger International"</li>
            <li><span className="font-medium">Adresse :</span> 61 Lordou Vironos str., 6023 Larnaca, Chypre</li>
            <li>
              <span className="font-medium">Site web :</span>{' '}
              <a
                href="https://www.hostinger.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                hostinger.fr
              </a>
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">4. Propriété intellectuelle</h2>
          <p className="text-gray-300 leading-relaxed">
            L'ensemble des éléments constituant ce site (textes, images, graphismes, logo, icônes,
            sons, logiciels, etc.) est la propriété exclusive de SOS IT Services, à l'exception des
            marques, logos ou contenus appartenant à d'autres sociétés partenaires ou auteurs.
          </p>
          <p className="mt-3 text-gray-300 leading-relaxed">
            Toute reproduction, représentation, modification, publication, adaptation de tout ou
            partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite,
            sauf autorisation écrite préalable de SOS IT Services. Toute exploitation non autorisée
            du site ou de l'un quelconque des éléments qu'il contient sera considérée comme
            constitutive d'une contrefaçon.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">5. Responsabilité</h2>
          <p className="text-gray-300 leading-relaxed">
            SOS IT Services s'efforce de fournir des informations aussi précises que possible sur ce
            site. Toutefois, SOS IT Services ne pourra être tenu responsable des omissions,
            inexactitudes et carences dans la mise à jour, qu'elles soient de son fait ou du fait des
            tiers partenaires qui lui fournissent ces informations.
          </p>
          <p className="mt-3 text-gray-300 leading-relaxed">
            Tous les informations indiquées sur le site sont données à titre indicatif, et sont
            susceptibles d'évoluer. Par ailleurs, les renseignements figurant sur le site ne sont pas
            exhaustifs. SOS IT Services se réserve le droit d'apporter des corrections à tout moment
            sans préavis.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-bold text-white mb-3">6. Droit applicable et juridiction compétente</h2>
          <p className="text-gray-300 leading-relaxed">
            Les présentes mentions légales sont soumises au droit français. En cas de litige, les
            tribunaux français seront seuls compétents, sous réserve des dispositions légales
            impératives contraires.
          </p>
        </section>
      </div>
    </div>
  );
};

export default MentionsLegales;
